import { UploadFileStatus } from 'antd/lib/upload/interface';
import { FieldValueType } from 'api/tasks';

export enum FormQuestionGroup {
  ContactInfo = 'CONTACT_INFO',
  Text = 'TEXT',
  Number = 'NUMBER',
  Choices = 'CHOICES',
  Date = 'DATE',
  Rating = 'RATING',
  Attachment = 'ATTACHMENT',
  Currency = 'CURRENCY',
}

export enum FormGroupColor {
  ContactInfo = 'var(--blue-20)',
  Text = 'var(--purple-20)',
  Number = 'var(--teal-20)',
  Choices = 'var(--magenta-20)',
  Date = 'var(--cyan-20)',
  Rating = 'var(--yellow-20)',
  Attachment = 'var(--red-20)',
  Currency = 'var(--green-20)',
}

export enum FormQuestionType {
  Phone = 'PHONE',
  Email = 'EMAIL',
  TextShort = 'TEXT_SHORT',
  TextLong = 'TEXT_LONG',
  TextStatement = 'TEXT_STATEMENT',
  Number = 'NUMBER',
  ChoiceRadio = 'CHOICE_RADIO',
  ChoiceCheckbox = 'CHOICE_CHECKBOX',
  ChoiceDropdown = 'CHOICE_DROPDOWN',
  ChoiceDropdownMultiselect = 'CHOICE_DROPDOWN_MULTISELECT',
  MultipleChoiceGrid = 'MATRIX_CHECKBOX',
  CheckBoxGrid = 'MATRIX_RADIO',
  MatrixRow = 'MATRIX_ROW',
  Date = 'DATE',
  StarRating = 'STARS',
  Attachment = 'ATTACHMENT',
  Currency = 'CURRENCY',
}

export interface FormChoiceOption {
  optionId: number;
  optionLabel: string;
  questionId?: number;
  position: number;
  branches?: FormQuestion[];
  color?: string;
}

export enum FormQuestionMetaValue {
  Currency = 'CURRENCY',
  Phone = 'PHONE',
  StarRating = 'STARS',
}
export interface FormQuestion {
  formQuestionType: FormQuestionType;
  questionText: string;
  description: string;
  questionId: number;
  required: boolean;
  position: number;
  depth?: number;
  branchingFrom?: number;
  projectFieldId?: number;
  taskFieldId?: number;
  value?: FieldValueType;
  templateId?: number;
  parentId?: number;
  options?: FormChoiceOption[];
  placeholder?: string;
  questionMeta?: {
    type: FormQuestionMetaValue;
    currencySymbol?: string;
    countryCode?: number;
    numberOfStar?: number;
  };
  rows?: FormQuestion[];
}

export enum FormResponseType {
  SingleResponse = 'SINGLE_RESPONSE',
  MultipleResponse = 'MULTIPLE_RESPONSE',
}
export enum FormSharing {
  Restricted = 'RESTRICTED',
  Anyone = 'ANYONE',
}
export interface FormTheme {
  titleBarColor: string;
  headerColor: string;
  backgroundColor: string;
  buttonColor: string;
  backgroundImage?: string;
  headerImage?: string;
  lastUploadedHeaderImage?: string;
  brightness?: number;
  formCta?: string;
}

export interface FormTemplateTaskCreationConfig {
  projectTemplateId: number;
  phaseTemplateId: number;
}
export interface FormTemplateAutomationRuleOption {
  projectTemplateId: {
    label: string;
    value: number;
  };
  phaseTemplateId: {
    label: string;
    value: number;
  };
}
export interface FormTemplate {
  formSettings: {
    formResponseType: 'SINGLE_RESPONSE' | 'MULTIPLE_RESPONSE';
    formSharing: 'RESTRICTED' | 'ANYONE';
  };
  automation: {
    enabled: boolean;
    ruleEnabled: boolean;
    ruleList: FormTemplateTaskCreationConfig[];
  };
  formTheme: FormTheme;
  name: string;
  description: string;
  formQuestions: FormQuestion[];
  templateId: number;
  createdBy: number;
  createdAt: number;
  updatedBy: number;
  updatedAt: number;
  usageCount?: number;
}

export interface FormTemplateAutomationUpdate extends FormTemplate {
  updateAllInstance: boolean;
}

export interface CreateBranchingDetailsProps {
  optionId: number;
  questionId: number;
}
export enum FormThemeImageType {
  HeaderImage = 'HEADER_IMAGE',
  BackgroundImage = 'BACKGROUND_IMAGE',
}
export interface FormThemeImage {
  originFileObj?: File | Blob;
  status?: UploadFileStatus;
  location: string;
  name: string;
}

export interface ProjectTemplatePhase {
  projectTemplateName: string;
  projectTemplateId: number;
  projectPhases: {
    phaseTemplateId: number;
    phaseTemplateName: string;
  }[];
}
